import { Step } from '@/widgets/ServiceFormTemplate';

import { Payment, SignUp } from '@/features/ui';
import { DeliveryAddress } from '@/features/ui/Steps/DeliveryAddress/DeliveryAddress';
import { deliveryAddressSchema } from '@/features/ui/Steps/DeliveryAddress/model/schemas';

import {
  birthAndRegistrationPlaceSchema,
  birthPlaceSchema,
  personalDataSchemaElectronic,
  personalDataSchemaPaper,
  purposeAndExtractTypeSchema,
} from '../../model/schemas';

import { ExtractFormType } from './../../lib/constants';
import { ServiceProps } from './../../model/types';
import { BirthPlaceAndRegistrationStep } from './BirthPlaceAndRegistrationStep';
import { DataPreviewStep } from './DataPreviewStep';
import { ExtractFormTypeStep } from './ExtractFormTypeStep';
import { PersonalDataStep } from './PersonalDataStep';
import { PurposeAndExtractTypeStep } from './PurposeAndExtractTypeStep';
import { ResultStep } from './ResultStep';

const formTypeStep: Step<ServiceProps> = {
  title: 'Форма витягу',
  step: ExtractFormTypeStep,
};

const purposeAndExtractTypeStep: Step<ServiceProps> = {
  title: 'Мета запиту і тип витягу',
  step: PurposeAndExtractTypeStep,
  validationSchema: purposeAndExtractTypeSchema,
};

const dataPreviewStep: Step<ServiceProps> = {
  title: 'Підтвердження даних',
  step: DataPreviewStep,
};

const signupStep: Step<ServiceProps> = {
  title: 'Електронний Підпис (КЕП)',
  step: SignUp,
};

const resultStep: Step<ServiceProps> = {
  title: 'Результат',
  step: ResultStep,
};

export const getSteps = (extractFormType: ExtractFormType, showPaymentStep: boolean): Array<Step<ServiceProps>> => {
  if (extractFormType === ExtractFormType.UNSET) return [formTypeStep];

  if (extractFormType === ExtractFormType.ELECTRONIC) {
    return [
      {
        ...formTypeStep,
        title: 'Форма витягу (електронний)',
      },
      {
        title: 'Особисті дані',
        step: PersonalDataStep,
        validationSchema: personalDataSchemaElectronic,
      },
      {
        title: 'Місце народження',
        step: BirthPlaceAndRegistrationStep,
        validationSchema: birthAndRegistrationPlaceSchema,
      },
      { ...purposeAndExtractTypeStep },
      { ...dataPreviewStep },
      { ...signupStep },
      { ...resultStep },
    ];
  }

  return [
    {
      ...formTypeStep,
      title: 'Форма витягу (паперовий)',
    },
    {
      title: 'Особисті та паспортні дані',
      step: PersonalDataStep,
      validationSchema: personalDataSchemaPaper,
    },
    {
      title: 'Місце народження та реєстрації',
      step: BirthPlaceAndRegistrationStep,
      validationSchema: birthPlaceSchema,
    },
    { ...purposeAndExtractTypeStep },
    {
      title: 'Доставка',
      step: DeliveryAddress,
      validationSchema: deliveryAddressSchema,
    },
    { ...dataPreviewStep },
    { ...signupStep },
    ...(showPaymentStep
      ? [
          {
            title: 'Оплата',
            step: Payment,
          },
        ]
      : []),
    { ...resultStep },
  ];
};
